import React from 'react';
import { Link } from 'react-router-dom';

// Placeholder da tela de cadastro (ainda não implementada).
function SignUpPage() {
  return (
    <div className="auth-page min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <div className="auth-card w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:shadow-lg">
        <h1 className="auth-title text-2xl font-semibold text-slate-900">Realizar cadastro</h1>
        <p className="auth-description mt-2 text-sm text-slate-500">
          Placeholder para a tela de cadastro.
        </p>
        <Link
          to="/"
          className="auth-link mt-4 inline-flex items-center justify-center text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          Voltar para o login
        </Link>
      </div>
    </div>
  );
}

export default SignUpPage;
